import * as React from "react";

interface ToastProps {
	id: string;
	title: string;
	description?: string;
	status: "success" | "error" | "info";
	duration?: number;
}

interface ToastContextValue {
	showToast: (toast: Omit<ToastProps, "id">) => void;
}

export const ToastContext = React.createContext<ToastContextValue | undefined>(undefined);

export function useToast() {
	const context = React.useContext(ToastContext);
	if (!context) {
		throw new Error("useToast must be used within a ToastProvider");
	}
	return context;
}
